export default __webpack_public_path__ + "static/media/IfStatementsImg.36f463d0.jpg";